import { initializeSwiper } from './splide-config';
import { setupFavouritableCardListeners } from './_favouriting';

window.addEventListener('load', () => {

    const BLOCK_WIDTH_MAP = {
        "<12.5M": { min: null, max: 12.5, maxIncluded: false },
        "12.5-15M": { min: 12.5, max: 15, minIncluded: true, maxIncluded: true },
        ">15M": { min: 15, max: null, minIncluded: false }
    };

    const showElement = (element) => element?.classList.remove('hidden');
    const hideElement = (element) => element?.classList.add('hidden');

    const getActiveFilters = () => {
        let filters = {};
        document.querySelectorAll('[data-filter-type="click"]').forEach(filter => {
            const filterField = filter.getAttribute('data-filter-field');
            const valueContainer = filter.querySelector("[data-filter-value-container][data-active='true']");
            const value = valueContainer?.querySelector('span')?.innerText;
            if (value) filters[filterField] = value; // Keep "Any" for filter flags visibility
        });
        return filters;
    };

    const updateClearFilterButton = () => {
        const filters = getActiveFilters();
        const hasActiveFilters = Object.values(filters).some(value => value !== "Any"); // Check if there are filters other than "Any"
        const clearFilterBtn = document.querySelector('#clearFilterBtn');
        if (clearFilterBtn) {
            if (hasActiveFilters) {
                showElement(clearFilterBtn);
            } else {
                hideElement(clearFilterBtn);
            }
        }
    };

    const applyFilters = () => {
        const filters = getActiveFilters();
        updateClearFilterButton(); // Update clear filters button visibility

        Object.entries(filters).forEach(([filterField, filterValue]) => setFilterFlag(filterField, filterValue));

        // This should be called after setFilterFlag
        const showInterstitials = !isFilterEnabled();

        // Reset slides
        const homeGrid = document.querySelector('#homeGrid .swiper-wrapper');
        homeGrid.innerHTML = "";
        let homeGroups = [];
        let currentGroup = [];

        const homeSlider = document.querySelector('#homeSlider .swiper-wrapper');
        if (homeSlider) {
            homeSlider.innerHTML = "";
        }
        let homeSlides = [];

        document.querySelectorAll('#allHomeDesigns [data-filterable], #allHomeDesigns .interstitial-card').forEach(filterable => {
            let showThis = true;
            for (let [filterField, filterValue] of Object.entries(filters)) {
                if (!showThis) break;
                const attributeName = `data-${filterField}`;
                let filterableValue = filterable.getAttribute(attributeName);
                let isFilterSatisfied = filterValue === "Any" || (showInterstitials && filterable.classList.contains("interstitial-card"));
                if (!isFilterSatisfied) {
                    switch (filterField) {
                        case 'block-width':
                            const range = BLOCK_WIDTH_MAP[filterValue];
                            let value = parseFloat(filterableValue);
                            let passed = (!range.min || (range.minIncluded ? range.min <= value : range.min < value)) &&
                                (!range.max || (range.maxIncluded ? value <= range.max : value < range.max));
                            isFilterSatisfied = passed;
                            break;
                        default:
                            isFilterSatisfied = filterableValue === filterValue;
                    }
                }
                showThis = showThis && isFilterSatisfied;
            }

            if (showThis) {
                showElement(filterable);
                const isPartOfHiddenSlides = filterable.closest('#hiddenSlides');

                if (isPartOfHiddenSlides) {
                    const parent = filterable.closest(".swiper-slide");
                    const clone = parent.cloneNode(true);
                    if (parent.dataset.stacked === 'true') {
                        homeSlides.push(clone);
                    } else {
                        currentGroup.push(clone);
                    }

                    if (currentGroup.length === 10) {
                        homeGroups.push([...currentGroup]);
                        currentGroup = [];
                    }
                }
            } else {
                hideElement(filterable);
            }
        });

        if (currentGroup.length) homeGroups.push([...currentGroup]);

        homeGroups.forEach(group => {
            let slide = document.createElement("div");
            slide.classList.add("swiper-slide", "w-full", "h-full", 'bg-gray-light-1');

            let gridContainer = document.createElement("div");
            gridContainer.classList.add("w-full", "h-full", "grid", "grid-cols-5", "grid-rows-2", "gap-5");

            group.forEach(home => gridContainer.appendChild(home));
            slide.appendChild(gridContainer);
            homeGrid.appendChild(slide);
        });

        if (homeSlides.length) {
            let slidesToAdd = [...homeSlides];
            homeSlider.dataset.manualClones = '0';
            homeSlider.dataset.uniqueManualClones = '0';

            if (homeSlides.length === 1) {
                homeSlider.dataset.uniqueManualClones = '1';
                homeSlider.dataset.manualClones = '3';
                slidesToAdd = slidesToAdd.concat(homeSlides, homeSlides, homeSlides);
            } else if (homeSlides.length <= 3) {
                homeSlider.dataset.manualClones = homeSlides.length;
                homeSlider.dataset.uniqueManualClones = homeSlides.length;
                slidesToAdd = slidesToAdd.concat(homeSlides);
            }

            slidesToAdd.forEach((slide, index) => {
                const clone = slide.cloneNode(true);
                clone.setAttribute('data-slide-index', index);
                homeSlider.appendChild(clone);
            });
        }

        // Reinitialize favouritable card listeners for all the slides
        const favouritables = document.querySelectorAll("#homeSlider .swiper [data-favouritable-card], #homeGrid .swiper [data-favouritable-card]");
        favouritables.forEach((favouritable) => {
            setupFavouritableCardListeners(favouritable);
        });

        const containers = document.querySelectorAll('#featureDisplays, #homeGrid, #homeSlider');
        containers.forEach((container) => {
            const showWhenEmpty = container.querySelector('.show-when-empty');
            if (showWhenEmpty) {
                if (container.querySelectorAll('[data-favouritable-card]:not(.hidden)').length > 0) {
                    hideElement(showWhenEmpty);
                } else {
                    showElement(showWhenEmpty);
                }
            }
        });

        initializeSwiper();
        document.querySelectorAll("#homeGrid .swiper [data-favouritable-card]").forEach(setupFavouritableCardListeners);
    };

    const setFilterFlag = (filterField, filterValue) => {
        const filterFlag = document.querySelector(`[data-filter-flag-field="${filterField}"]`);
        if (filterFlag) {
            if (filterValue === 'Any') {
                filterFlag.parentElement.classList.add('hidden');
            } else {
                filterFlag.innerText = (filterField === 'beds' || filterField === 'baths') ? `${filterValue} ${filterField.charAt(0).toUpperCase() + filterField.slice(1)}` : filterValue;
                filterFlag.parentElement.classList.remove('hidden');
            }
        }
    };

    const isFilterEnabled = () => {
        const filters = document.querySelectorAll("#filterFlags [data-filter-flag]:not(.hidden)");
        return filters.length > 0;
    };

    const initializeClearFilters = () => {
        document.querySelectorAll('#clearFilters button, .system-reset button, #clearFilterBtn button').forEach(button => {
            button.addEventListener('pointerdown', () => {
                document.querySelectorAll('[data-filter-type="click"] [data-filter-value-container]').forEach(container => {
                    if (container.querySelector('span')?.innerText === 'Any') activateClickFilterValue(container);
                });
                applyFilters();
            });
        });
    };

    const initializeClickFilters = () => {
        document.querySelectorAll('[data-filter-type="click"] [data-filter-value-container]').forEach(container => {
            container.addEventListener("pointerdown", () => {
                activateClickFilterValue(container);
                applyFilters();
            });
        });
    };

    const activateClickFilterValue = (container) => {
        container.closest('[data-filter-type="click"]')?.querySelectorAll('[data-filter-value-container][data-active="true"]').forEach(active => active.dataset.active = false);
        container.dataset.active = true;
    };

    initializeSwiper();
    initializeClickFilters();
    initializeClearFilters();
    applyFilters();
});
